export default "__VITE_ASSET__ndRSLI6b__"